import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2e875912")

_pushScopeId("data-v-2e875912")
const _hoisted_1 = /*#__PURE__*/_createVNode("div", null, "1.应用上线申请", -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 应用主页： ", -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 可信域名： ", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 代开发应用回调URL： ", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "label" }, " Token： ", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, " EncodingAESKey： ", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_12 = /*#__PURE__*/_createVNode("div", null, "2.授权范围和功能配置", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 确认可见范围为企业组织架构根目录，授权功能权限已授权 ", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, "3.侧边栏菜单配置", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("复制")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("确认完成以上配置")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_divider = _resolveComponent("a-divider")
  const _component_a_image = _resolveComponent("a-image")
  const _component_a_modal = _resolveComponent("a-modal")

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.visible,
    "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.visible = $event)),
    title: "代开发应用配置",
    width: "700px",
    maskClosable: false,
    keyboard: false,
    afterClose: _ctx.close,
    class: "config-modal"
  }, {
    footer: _withId(() => [
      _createVNode(_component_a_button, {
        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.visible = false))
      }, {
        default: _withId(() => [
          _hoisted_16
        ]),
        _: 1
      }),
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _ctx.submit
      }, {
        default: _withId(() => [
          _hoisted_17
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    default: _withId(() => [
      _hoisted_1,
      _createVNode("ul", null, [
        _createVNode("li", null, [
          _hoisted_2,
          _createVNode("span", null, _toDisplayString(_ctx.value?.homePageUrl), 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.copyText(_ctx.value?.homePageUrl)))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          })
        ]),
        _createVNode("li", null, [
          _hoisted_4,
          _createVNode("span", null, _toDisplayString(_ctx.value?.domain), 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.copyText(_ctx.value?.domain)))
          }, {
            default: _withId(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_divider),
        _createVNode("li", null, [
          _hoisted_6,
          _createVNode("span", null, _toDisplayString(_ctx.value?.callbackUrl), 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.copyText(_ctx.value?.callbackUrl)))
          }, {
            default: _withId(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createVNode("li", null, [
          _hoisted_8,
          _createVNode("span", null, _toDisplayString(_ctx.value?.token), 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyText(_ctx.value?.token)))
          }, {
            default: _withId(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _createVNode("li", null, [
          _hoisted_10,
          _createVNode("span", null, _toDisplayString(_ctx.value?.aesKey), 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.copyText(_ctx.value?.aesKey)))
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_a_divider),
      _hoisted_12,
      _createVNode("ul", null, [
        _createVNode("li", null, [
          _hoisted_13,
          _createVNode(_component_a_image, {
            width: 50,
            height: 50,
            src: require('@/assets/images/bussinessConfig.png')
          }, null, 8, ["src"])
        ])
      ]),
      _createVNode(_component_a_divider),
      _hoisted_14,
      _createVNode("ul", null, [
        _createVNode("li", null, [
          _createVNode("span", null, _toDisplayString(_ctx.value?.sidePageUrl), 1),
          _createVNode(_component_a_button, {
            type: "link",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.copyText(_ctx.value?.sidePageUrl)))
          }, {
            default: _withId(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_a_image, {
            width: 50,
            height: 50,
            src: require('@/assets/images/dkf1.png')
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible", "afterClose"]))
})